import React from 'react';
import { CheckOutlined } from '@ant-design/icons';

import styles from '../Components.module.css';

import { PaddleUpgrade } from './PaddleUpgrade';
import { featureCategories, plans, UpgradeState } from './Plans';
import { PlanButton } from './PlanButton';
import Logo from '../Logo';

const DetailedUpgradeView = () => {
  // TODO refactor this in to redux
  const [upgradeState, setUpgradeState] = React.useState(UpgradeState.default);
  const [selectedPlan, setSelectedPlan] = React.useState<any | undefined>(
    undefined
  );

  if (upgradeState === UpgradeState.awaitingConfirmation) {
    return (
      <PaddleUpgrade
        selectedPlan={selectedPlan}
        setUpgradeState={setUpgradeState}
      />
    );
  }

  return (
    <div className={styles.giideDetailedPlansScroll}>
      <div className={styles.giideDetailedPlans}>
        <div className={styles.giideDetailedPlansRow}>
          <div className={styles.giidePlansLogoTitle}>
            <div className={styles.giidePlansLogo}>
              <Logo />
            </div>
            <div className={styles.giidePlansLogoUnderbar} />
            <div>Plans & Pricing</div>
          </div>
          {plans.map((plan, index) => (
            <div
              key={`${plan.planId}-${index}`}
              className={styles.giidePlansTitle}
            >
              <div>{plan.title}</div>
              <div />
              <div className={styles.giidePlanPrice}>
                <span>{plan.price}</span>
                <span>/month</span>
              </div>
              {plan.title !== 'Business' ? <span>per Creator</span> : <span />}
              <PlanButton
                plan={plan}
                setUpgradeState={setUpgradeState}
                setSelectedPlan={setSelectedPlan}
              />
            </div>
          ))}
        </div>
        <div className={styles.giidePlansDetails}>
          {Object.keys(featureCategories).map(category => {
            return (
              <div key={category}>
                <div className={styles.giideFeaturesTitle}>{category}</div>
                {Object.keys(featureCategories[category]).map(
                  (feature, idx) => {
                    return (
                      <div
                        key={`${feature}-${idx}`}
                        className={styles.giidePlansFeatureRow}
                      >
                        <div>{feature}</div>
                        {plans.map((plan, i) => {
                          const featureValue = plan.features[category][feature];
                          let featureToShow;
                          if (typeof featureValue === 'string') {
                            featureToShow = featureValue;
                          } else {
                            featureToShow = featureValue ? (
                              <CheckOutlined />
                            ) : (
                              '-'
                            );
                          }

                          const style =
                            feature === 'Number of giides'
                              ? { fontWeight: '600' }
                              : undefined;

                          return (
                            <div
                              key={`${plan.planId}-${feature}-${i}`}
                              style={style}
                            >
                              {featureToShow}
                            </div>
                          );
                        })}
                      </div>
                    );
                  }
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DetailedUpgradeView;
